import { CurrentTradingTimeShiftFragment } from '../modules/graphql/service/graphql-auto-main-service';
import { DateTime } from 'luxon';
import { AutoLotView } from '../const';

export function pickCurrentTradingTimeShift(
  tradingTimeShifts: CurrentTradingTimeShiftFragment[] | null | undefined,
  lot: AutoLotView | null | undefined,
): CurrentTradingTimeShiftFragment | null {
  if (!tradingTimeShifts?.length || !lot?.date || !lot?.bid) return null;

  const lotDay = DateTime.fromISO(lot.date, { zone: 'utc' }).toISODate();
  if (!lotDay) return null;

  const bidNumber = Number(lot.bid);

  if (!Number.isFinite(bidNumber)) return null;

  return (
    tradingTimeShifts.find((tradingTimeShift) => {
      const dateTime = parseShiftDate(tradingTimeShift.auctionDate);

      if (!dateTime.isValid || dateTime.toISODate() !== lotDay) return false;

      const from = Number(tradingTimeShift.codeFrom);
      const to = Number(tradingTimeShift.codeTo);

      if (!Number.isFinite(from) || !Number.isFinite(to)) return false;

      const min = Math.min(from, to);
      const max = Math.max(from, to);

      return bidNumber >= min && bidNumber <= max;
    }) ?? null
  );
}

function parseShiftDate(auctionDate: string): DateTime {
  const dateTime = DateTime.fromFormat(auctionDate, "yyyy-LL-dd HH:mm:ss 'UTC'", { zone: 'utc' });
  return dateTime.isValid ? dateTime : DateTime.fromISO(auctionDate, { zone: 'utc' });
}
